import {
  useCanInteractWithWorkspaceQuery,
  useHasSsoIntegrationQuery,
} from "@modules/organization/queries.generated"
import { LocalStorageItems } from "@modules/localStorage/constants"

type Options = {
  skip: boolean
}

export function useSecureWorkspace(
  organizationId: `string`,
  { skip = true }: Options
) {
  const ssoToken = localStorage.getItem(LocalStorageItems.GatsbySsoToken)

  const hasSSOIntegration = useHasSsoIntegrationQuery({
    variables: { workspaceId: organizationId },
    fetchPolicy: "cache-and-network",
    skip: skip,
  })

  const canInteractWithWorkspace = useCanInteractWithWorkspaceQuery({
    variables: { workspaceId: organizationId, token: ssoToken },
    fetchPolicy: "cache-and-network",
    skip: skip,
  })

  if (skip) {
    return null
  }

  return {
    hasSsoIntegration: hasSSOIntegration.data?.hasSSOIntegration,
    isReadyToInteract: canInteractWithWorkspace.data?.canInteractWithWorkspace,
    loading: hasSSOIntegration.loading || canInteractWithWorkspace.loading,
    error: hasSSOIntegration.error || canInteractWithWorkspace.error,
  }
}
